import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/ambassador-reminders")({
  component: lazyRouteComponent(() => import("./-pages/admin.ambassador-reminders")),
  head: () => ({ meta: [{ title: "تذكيرات السفراء — Lecmo Admin" }] }),
});
